import { connect } from 'react-redux'
import {
  setAccountFormField,
  setAccountForm,
  mergeAccountForm
} from 'actions/account/account'

const mapStateToProps = ({ account: { form } }) => ({ form })

const actions = { setAccountFormField, setAccountForm, mergeAccountForm }

const withRedux = connect(mapStateToProps, actions)

export default withRedux
